// Back to top: scrolls the window to 0 (smooth unless the visitor prefers reduced motion), then
// snaps to 0 if layout shifts (content-visibility, resize) interrupted the smooth scroll.
// The wrapped <a href="#top"> stays as the no-JavaScript fallback.
class SBackToTop extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.addEventListener('click', (event) => this.onClick(event), { signal: this.controller.signal });
  }

  onClick(event) {
    const link = event.target instanceof Element ? event.target.closest('a[href="#top"]') : null;
    if (!link) return;
    event.preventDefault();

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });

    if (!reduceMotion) {
      this.cleanup?.abort();
      const cleanup = new AbortController();
      this.cleanup = cleanup;
      const settle = () => {
        cleanup.abort();
        if (window.scrollY !== 0) window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      };
      window.addEventListener('scrollend', settle, { once: true, signal: cleanup.signal });
      const timer = window.setTimeout(settle, 1500);
      cleanup.signal.addEventListener('abort', () => window.clearTimeout(timer));
    }

    const target = document.getElementById('top');
    if (target) {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.cleanup?.abort();
  }
}

if (!customElements.get('s-back-to-top')) customElements.define('s-back-to-top', SBackToTop);
